import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import ImageCard from '../ImageCard';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import FuneralDirectorInfo from './FuneralDirectorInfo';

type TProps = {
    details: IOnlineCondolenceDetails;
}

const FuneralDirectorCard = ({details}: TProps) => {
    const { publicUrl } = useSettingsContext();

    return (
        <ImageCard
            imageSrc={details.assignedToImageUrl ?? `${publicUrl}/placeholder-funeral-director.jpg`}
            placeholderSrc={`${publicUrl}/placeholder-funeral-director.jpg`}
            imageAlt={details.assignedToDisplayName ?? ''}
        >
            <div className="cr-p-lg cr-flex cr-flex-col cr-gap-sm cr-text-secondary">
                <FuneralDirectorInfo details={details}/>
            </div>
        </ImageCard>
    );
}

export default FuneralDirectorCard;
